export class CompaniesSubscriptionEntity {  
    id?: number;
    startDate?: string;
    endDate?: string | null;
}